// extracted by mini-css-extract-plugin
export default {"mainCont":"SupervisorOrderHistory_mainCont__WK5lk","TableDiv":"SupervisorOrderHistory_TableDiv__1o0iR"};